import { Icon } from '@/components/Icon'
import React from 'react'

// 选项卡片属性
export interface OptionCardProps {
  /** 选项名称 */
  name: string
  /** 图标名称 */
  icon: string
  /** 描述文字 */
  describe: string
  /** 是否选中 */
  selected?: boolean
  /** 点击回调 */
  onClick?: () => void
  /** 自定义类名 */
  className?: string
  /** 图标大小 */
  iconSize?: number
  /** 卡片宽度 */
  width?: string
  /** 卡片高度 */
  height?: string
}

const OptionCard: React.FC<OptionCardProps> = ({
  name,
  icon,
  describe,
  selected = false,
  onClick,
  className,
  iconSize = 20,
  width = '370px',
  height = '100px',
}) => {
  return (
    <div
      className={`
        rounded-lg border cursor-pointer transition-all
        ${
          selected
            ? 'border-[#8752ff] bg-[rgba(78,87,254,0.03)]'
            : 'border-[#eff3fd] bg-white'
        }
        ${className || ''}
      `}
      style={{ width, height }}
      onClick={onClick}
    >
      <div className="flex items-start py-2 px-3 h-full">
        {/* 内容区域 */}
        <div className="flex-1">
          {/* 上部分：图标和名称 */}
          <div className="flex items-center mb-2">
            <Icon name={icon} size={iconSize} className="mr-2" />
            <span className="text-base text-[#000000] font-medium">
              {name}
            </span>
          </div>
          
          {/* 下部分：描述 */}
          <div className="text-sm text-[#888888] leading-relaxed">
            {describe}
          </div>
        </div>

        {/* 单选按钮 */}
        <div className="flex-shrink-0 ml-3 mt-1">
          <div
            className={`
              w-4 h-4 rounded-full border-2 flex items-center justify-center
              ${
                selected ? 'border-[#8752ff]' : 'border-gray-300'
              }
            `}
          >
            {selected && (
              <div className="w-2 h-2 rounded-full bg-[#8752ff]" />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default OptionCard
